import {memo, type PropsWithChildren} from 'react'
import type {FeatureFlag} from '../@types/entity/User'
import {useUserHelperGetCurrent} from '../hooks/entity/useUser'

interface Props extends PropsWithChildren {
  featureFlag: FeatureFlag
}

export const useHasFeatureFlag = (featureFlag: FeatureFlag): boolean => {
  const {user} = useUserHelperGetCurrent()

  return !!user?.featureFlags.includes(featureFlag)
}

export const FeatureFlagOnly = memo(({featureFlag, children}: Props) => {
  const hasFeatureFlag = useHasFeatureFlag(featureFlag)
  if (!hasFeatureFlag) {
    return null
  }

  return children
})
